import React from 'react';
import Pagination from 'react-bootstrap/Pagination';
import './css/pagination.css';

class TablePagination extends React.PureComponent {
  onPageChange = (e) => {
    const newpage = parseInt(e.target.getAttribute('pageno'));
    this.props.onPageChange(newpage);
  }

  render() {
    if (this.props.totalpage === 0 || this.props.totalpage === 1) {
      return null;
    }

    const totalpage = this.props.totalpage;
    const currentpage = this.props.currentpage;
    const groupCount = this.props.config.PAGINATION_GROUP_COUNT;
    let totalgroup = 1;
    let currentgroup = 1;

    if (totalpage > groupCount) {
      if (totalpage / groupCount > parseInt(totalpage / groupCount)) {
        totalgroup = parseInt(totalpage / groupCount) + 1;
      } else {
        totalgroup = parseInt(totalpage / groupCount);
      }
      if (currentpage / groupCount > parseInt(currentpage / groupCount)) {
        currentgroup = parseInt(currentpage / groupCount) + 1;
      } else {
        currentgroup = parseInt(currentpage / groupCount);
      }
    }

    const lastGroupDigit = (totalpage % groupCount === 0) ? groupCount : totalpage % groupCount;
    const indexStart = ((currentgroup - 1) * groupCount) + 1;
    const indexEnd = (currentgroup !== totalgroup) ? currentgroup * groupCount : ((currentgroup - 1) * groupCount) + lastGroupDigit;

    let items = [];
    if (currentgroup !== 1 && totalgroup > 1) {
      items.push(
        <Pagination.Item key='first' onClick={this.onPageChange} pageno={1}>
          1
        </Pagination.Item>
      );
      items.push(
        <Pagination.Ellipsis key='prev' onClick={this.onPageChange} pageno={(indexStart - 1)} />
      );
    }
    for (let i = indexStart; i <= indexEnd; i++) {
      items.push(
        <Pagination.Item key={i} active={i === currentpage} onClick={this.onPageChange} pageno={i}>
          {i}
        </Pagination.Item>
      );
    }
    if (currentgroup !== totalgroup && totalgroup > 1) {
      items.push(
        <Pagination.Ellipsis key='next' onClick={this.onPageChange} pageno={(indexEnd + 1)} />
      );
      items.push(
        <Pagination.Item key='last' onClick={this.onPageChange} pageno={totalpage}>
          {totalpage}
        </Pagination.Item>
      );
    }
    return (
      <div className="d-flex justify-content-center">
        <Pagination className='mb-0 mt-3'>{items}</Pagination>
      </div>
    )
  }
}

export default TablePagination;